import styled from 'styled-components';
import LinkHandler from '../../link-handler';
import { buttonReset, buttonStyles } from '../../styled/buttons';
import { multiplyPx } from '../../styled/utils';
import { breakpoint } from '../../theme/breakpoint';

const doublePx = multiplyPx(2);
const halfPx = multiplyPx(0.5);

export const MapModal = styled.img`
  height: 64px;
`;

export const MapNav = styled.img`
  height: 32px;
`;

export const Link = styled(LinkHandler)`
  ${buttonReset};
  ${buttonStyles};
`;

// Country Switch nav button styles
export const CountrySwitcher = styled.div`
  font-size: ${({ theme }) => theme.fontsize.small};
  text-transform: uppercase;
  margin: ${({ theme }) => theme.spacing.medium} auto;

  ${breakpoint.desktop`
    margin: 0 ${({ theme }) => theme.spacing.medium} 0 0;
  `}

  *:nth-child(2) {
    margin-left: ${({ theme }) => theme.spacing.small};
  }
  *:nth-child(3) {
    margin-left: ${({ theme }) => theme.spacing.standard};
  }
`;

export const CountryThis = styled.span`
  color: ${({ theme }) => theme.palette.secondaryText};
  padding-bottom: ${({ theme }) => halfPx(theme.spacing.tiny)};
  border-bottom: 2px solid ${({ theme }) => theme.palette.borderDark};
`;

export const CountryThat = styled.button`
  ${buttonReset};
  color: ${({ theme }) => theme.palette.standardText};
  text-transform: uppercase;
  text-decoration: none;

  &:focus,
  &:hover {
    text-decoration: none;
    color: ${({ theme }) => theme.palette.primaryLink};
  }
`;

// Country Switch modal internal content styles
export const CountryModalInner = styled.div`
  width: 100%;
  max-width: 470px;
  padding: ${({ theme }) => theme.spacing.standard};
  text-align: center;

  ${breakpoint.tablet`
    padding-left: ${({ theme }) => doublePx(theme.spacing.xlarge)};
    padding-right: ${({ theme }) => doublePx(theme.spacing.xlarge)};
  `}

  > img {
    margin-top: ${({ theme }) => theme.spacing.standard};
  }

  > h4 {
    margin-top: ${({ theme }) => theme.spacing.medium};
    margin-bottom: ${({ theme }) => theme.spacing.small};
  }

  > p {
    margin-bottom: ${({ theme }) => theme.spacing.medium};
  }

  > a {
    margin-bottom: ${({ theme }) => theme.spacing.standard};
  }

  > button {
    margin-bottom: ${({ theme }) => theme.spacing.tiny};
  }
`;
